import * as React from 'react'
import { clsx } from 'clsx'

import { mapKeyboardKey } from '../../helpers/mapKeyboardKey'

import styles from './Kbd.module.css'

type KbdProps = React.HTMLAttributes<HTMLElement> & {
  className?: string
  children: React.ReactNode
  color?: 'default' | 'inverted'
}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(
  ({ children, className, color, ...props }: KbdProps, forwardedRef) => {
    return (
      <kbd
        ref={forwardedRef}
        className={clsx(
          styles.kbd,
          color === 'inverted' && styles.inverted,
          className,
        )}
        {...props}
      >
        {typeof children === 'string' ? mapKeyboardKey(children) : children}
      </kbd>
    )
  },
)

Kbd.displayName = 'Kbd'

export { Kbd }
export type { KbdProps }
